import { getWebhooks } from '../../api';
import { useListFetch } from '../../hooks';
import type { WebhookItem, GetWebhooksFilters } from '../../api';

export const useWebhooks = () => {
  return useListFetch<WebhookItem, GetWebhooksFilters>(
    async params => {
      const result = await getWebhooks(
        params?.filters || {},
        params?.pagination
      );

      return { content: result };
    },
    { initialFilters: { campaignId: '', eventType: '' }, withQueryParams: true }
  );
};
